import { x, b, u, k, r as register } from "./preact-core.js";
import { l as layout, s as setMoney } from "./layout-store.js";
import { S as SvgMinus, a as SvgPlus, V as VariantSelects } from "./minus.js";
import { C as CustomSelect } from "./custom-select.js";
import "./utilities.js";
import "./lodash-utils.js";
class ProductFormQty extends x {
  constructor(props) {
    super(props);
    this.setQty = (arg) => {
      let direction = void 0;
      if (arg && typeof arg === "object" && "direction" in arg) {
        direction = arg.direction;
      }
      let value = parseInt(this.qtyInput.current.value);
      const min = this.props.minQty != null ? parseInt(this.props.minQty.toString()) : 0;
      const max = this.props.maxQty != null ? parseInt(this.props.maxQty.toString()) : 99;
      if (isNaN(value)) value = min;
      if (value < min) value = min;
      let exceededMax = false;
      if (value > max) {
        value = max;
        exceededMax = true;
      }
      if (direction) {
        if (direction === "up") {
          if (value >= max) {
            exceededMax = true;
          }
        } else if (direction === "down") {
          if (value <= min) {
            value = min;
          }
        }
      }
      if (this.qtyInput.current.value !== value.toString()) {
        this.qtyInput.current.value = value.toString();
      }
      this.setState({ qty: value });
      if (this.props.onQtyChange) {
        this.props.onQtyChange(value);
      }
      if (exceededMax && this.props.onMaxQtyReached) {
        this.props.onMaxQtyReached();
      }
    };
    this.getQtyOptions = () => {
      const options = [];
      for (let i = 1; i <= 10; i++) {
        options.push({
          id: `qty ${i}`,
          label: i.toString(),
          value: i
        });
      }
      return options;
    };
    this.getDefaultQty = () => {
      if (this.props.defaultQty != null) {
        return {
          label: this.props.defaultQty.toString(),
          value: this.props.defaultQty,
          id: `qty ${this.props.defaultQty}`
        };
      }
      return {
        id: "qty 1",
        label: "1",
        value: 1
      };
    };
    this.qtyInput = b();
    this.type = this.props.type ? this.props.type : "number";
    this.show_buttons = this.props.showButtons !== void 0 ? this.props.showButtons : false;
    this.state = {
      qty: this.props.defaultQty != null ? this.props.defaultQty : 1
    };
  }
  componentDidUpdate(previousProps, previousState, snapshot) {
    if (this.props.defaultQty !== previousProps.defaultQty && this.props.defaultQty !== null && this.props.defaultQty !== void 0 && this.state.qty !== this.props.defaultQty) {
      if (this.qtyInput.current) {
        this.qtyInput.current.value = this.props.defaultQty.toString();
      }
      this.setState({ qty: this.props.defaultQty }, () => {
        if (this.props.onQtyChange) {
          this.props.onQtyChange(this.props.defaultQty);
        }
      });
    }
  }
  render() {
    return /* @__PURE__ */ u(k, { children: /* @__PURE__ */ u("div", { class: "product-form__qty-wrap flex justify-between", children: [
      this.type === "number" && /* @__PURE__ */ u("div", { class: "product-form__qty h-full", children: /* @__PURE__ */ u("div", { class: "product-form__qty-controls", children: /* @__PURE__ */ u(k, { children: [
        this.show_buttons && /* @__PURE__ */ u(
          "button",
          {
            type: "button",
            class: "border-gold border-y-1 border-l-1",
            onClick: () => {
              var _a;
              (_a = this.qtyInput.current) == null ? void 0 : _a.stepDown();
              this.setQty({ direction: "down" });
            },
            children: /* @__PURE__ */ u(SvgMinus, {})
          }
        ),
        /* @__PURE__ */ u("div", { class: "product-row__qty-control", children: /* @__PURE__ */ u(
          "input",
          {
            class: "qtyInput",
            type: "number",
            "aria-label": "Quantity",
            ref: this.qtyInput,
            onInput: (e) => this.setQty(e),
            onChange: (e) => this.setQty(e),
            value: this.state.qty,
            min: "0",
            max: this.props.maxQty != null ? this.props.maxQty.toString() : "99",
            step: "1"
          }
        ) }),
        this.show_buttons && /* @__PURE__ */ u(
          "button",
          {
            type: "button",
            class: "border-gold border-x-1 border-y-1",
            onClick: () => {
              var _a;
              (_a = this.qtyInput.current) == null ? void 0 : _a.stepUp();
              this.setQty({ direction: "up" });
            },
            children: /* @__PURE__ */ u(SvgPlus, {})
          }
        )
      ] }) }) }),
      this.type === "select" && /* @__PURE__ */ u("div", { class: "relative max-w-[320px]", children: /* @__PURE__ */ u(
        CustomSelect,
        {
          title: "Select Quantity",
          default: this.getDefaultQty(),
          options: this.getQtyOptions(),
          onSelected: (e) => {
            console.log("Selected qty:", e);
            this.setState({ qty: e.value.value });
            if (this.props.onQtyChange) {
              this.props.onQtyChange(e.value.value);
            }
          }
        }
      ) })
    ] }) });
  }
}
const oneTimePurchase = {
  id: 0,
  name: "One time purchase",
  description: "",
  label: "One time purchase",
  value: 0,
  price_adjustments: []
};
class ProductForm extends x {
  constructor(props) {
    super(props);
    this.renderProductInfo = () => {
      const requestedVariantId = this.state.selectedVariant.id;
      fetch(`${this.props.url}?variant=${requestedVariantId}`).then((response) => {
        return response.text();
      }).then((responseText) => {
        if (this.state.selectedVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.updateVariantFE(html);
      });
    };
    this.handleSubmit = (evt) => {
      evt.preventDefault();
      if (this.state.availability != "addToCart") return;
      this.layout.cartError.value = null;
      this.setState({ loading: true });
      let item = {
        id: this.state.selectedVariant.id,
        quantity: this.state.qty
      };
      if (this.state.selectedSellingPlan && this.state.selectedSellingPlan.id != 0) {
        item.selling_plan = this.state.selectedSellingPlan.id;
      }
      let items = [item];
      const body = JSON.stringify({
        items
      });
      this.layout.cartAddItem(body).then((response) => {
        console.log("response", response);
        if (response.status) {
          this.layout.cartError.value = response.description;
          this.setState({ availability: "soldOut" });
        } else {
          this.layout.fetchCart().then(() => {
            this.layout.slideover.value = "cart";
            this.setState({ availability: "addToCart" });
          });
        }
      }).catch((e) => {
        this.setState({ loading: false });
        console.error(e);
      }).finally(() => {
        this.setState({ loading: false });
      });
    };
    console.log("product form props", props);
    this.state = {
      qty: 1,
      selectedSellingPlan: null,
      selectedVariant: JSON.parse(this.props.initialVariant),
      variantImagesFetched: false,
      loading: false,
      availability: this.props.initialAvailability == "true" ? "addToCart" : "soldOut",
      imagesUpdating: false,
      formattedSellingPlans: [],
      subscribeDiscount: null,
      price: "0"
    };
    this.layout = layout;
    this.productOptions = JSON.parse(this.props.productOptions);
    this.variantData = JSON.parse(this.props.variantData);
    this.variantMeta = JSON.parse(this.props.variantMeta);
    this.colorOptions = JSON.parse(this.props.colorOptions.replace(",]", "]"));
    this.sellingPlans = JSON.parse(this.props.sellingPlans);
    this.initialVariant = JSON.parse(this.props.initialVariant);
    this.requiresPlan = this.props.requiresPlan == "true" ? true : false;
    this.showQty = this.props.showQty == "true" ? true : false;
    this.updateUrl = this.props.updateUrl == "true" ? true : false;
    this.showQty = this.props.showQty == "true" ? true : false;
    this.optionStyle1 = this.props.optionStyle1 ? this.props.optionStyle1 : "selects";
    this.optionStyle2 = this.props.optionStyle2 ? this.props.optionStyle2 : "selects";
    this.optionStyle3 = this.props.optionStyle3 ? this.props.optionStyle3 : "selects";
    this.lastOptionStyle = this.props.lastOptionStyle ? this.props.lastOptionStyle : "selects";
    this.getPrice();
    this.setState({
      formattedSellingPlans: this.formatSellingPlans()
    });
  }
  componentDidUpdate(previousProps, previousState, snapshot) {
    if (this.state.selectedVariant.id != previousState.selectedVariant.id) {
      this.getPrice();
    }
  }
  updateVariant(value) {
    console.log("product form updateVariant", value);
    this.setState(
      {
        selectedVariant: value,
        availability: value && value.available ? "addToCart" : "soldOut"
      },
      () => {
        this.renderProductInfo();
      }
    );
  }
  updateVariantFE(html) {
    const updateElementSelectors = [
      `#product-images`,
      `#price-${this.props.section}`
    ];
    updateElementSelectors.forEach((selector) => {
      const liveElement = document.querySelector(selector);
      const newElement = html.querySelector(selector);
      if (newElement && liveElement) {
        this.replaceContent(newElement, liveElement, selector);
      }
    });
  }
  replaceContent(newEl, oldEl, selector) {
    if (selector.includes("product-images")) {
      const newElImg = newEl.querySelectorAll("img");
      const oldElImg = oldEl.querySelectorAll("img");
      let update = false;
      newElImg.forEach((img, index) => {
        if (img.src != oldElImg[index].src) {
          update = true;
        }
      });
      if (!update) {
        return;
      }
    }
    if (newEl && oldEl && newEl.innerHTML != oldEl.innerHTML) {
      oldEl.classList.add("fade-out");
      setTimeout(() => {
        oldEl.innerHTML = newEl.innerHTML;
        const currentEl = document.querySelector(`#${oldEl.id}`);
        if (selector.includes("product-images")) ;
        if (currentEl) {
          currentEl.classList.remove("fade-out");
          currentEl.classList.add("fade-in");
        }
      }, 200);
    } else {
      oldEl.innerHTML = newEl.innerHTML;
      this.setState({ variantImagesFetched: true });
    }
  }
  formatSellingPlans() {
    if (this.sellingPlans.length) {
      let planArray = this.sellingPlans.map((group) => {
        return {
          id: group.selling_plans[0].id,
          name: group.selling_plans[0].name,
          description: group.selling_plans[0].description,
          label: group.selling_plans[0].name,
          value: group.selling_plans[0].id,
          price_adjustments: group.selling_plans[0].price_adjustments
        };
      });
      if (!this.requiresPlan) {
        planArray.unshift(oneTimePurchase);
      }
      this.setState({ selectedSellingPlan: planArray[0] });
      return planArray;
    }
    return [];
  }
  setSelectedSellingPlan(data) {
    this.setState(
      {
        selectedSellingPlan: data,
        subscribeDiscount: {
          value: data.price_adjustments[0].value,
          value_type: data.price_adjustments[0].value_type
        }
      },
      () => {
        this.getPrice();
      }
    );
  }
  getPrice() {
    const sellingPlan = this.state.selectedSellingPlan;
    const selectedVariant = this.state.selectedVariant;
    let newPrice = setMoney("0");
    if (sellingPlan && sellingPlan.id != 0 && sellingPlan.price_adjustments[0]) {
      console.log("price sellingPlan", sellingPlan);
      const priceAdjuster = sellingPlan.price_adjustments[0];
      if (priceAdjuster.value_type == "percentage") {
        newPrice = setMoney(
          selectedVariant.price - selectedVariant.price * (priceAdjuster.value / 100)
        );
      }
      if (priceAdjuster.value_type == "fixed") {
        newPrice = setMoney(selectedVariant.price - priceAdjuster.value);
      }
    } else if (selectedVariant && selectedVariant.price) {
      newPrice = setMoney(selectedVariant.price);
    }
    this.setState({ price: newPrice });
  }
  render() {
    return /* @__PURE__ */ u(k, { children: /* @__PURE__ */ u("div", { class: "product-form", children: [
      /* @__PURE__ */ u("div", { class: `product-form__grid --${this.productOptions.length} `, children: this.initialVariant ? /* @__PURE__ */ u(
        VariantSelects,
        {
          section: this.props.section,
          url: this.props.url,
          updateUrl: this.updateUrl,
          productOptions: this.productOptions,
          colorOptions: this.colorOptions,
          initialVariant: this.initialVariant,
          variantData: this.variantData,
          option1Style: this.optionStyle1,
          option2Style: this.optionStyle2,
          option3Style: this.optionStyle3,
          lastOptionStyle: this.lastOptionStyle,
          updateVariant: this.updateVariant.bind(this),
          variantMeta: this.variantMeta,
          selectedVariant: this.state.selectedVariant
        }
      ) : "" }),
      this.state.availability == "addToCart" ? /* @__PURE__ */ u(k, { children: /* @__PURE__ */ u("div", { class: "product-form__buttons flex w-full", children: [
        this.showQty ? /* @__PURE__ */ u(ProductFormQty, {}) : null,
        /* @__PURE__ */ u(
          "button",
          {
            type: "button",
            class: `product-form__submit btn btn--outline --gold w-full ${this.state.loading && "loading"}`,
            "aria-disabled": this.state.loading || this.state.availability != "addToCart",
            disabled: this.state.loading || this.state.availability != "addToCart",
            onClick: this.handleSubmit,
            children: "Add To Cart"
          }
        )
      ] }) }) : /* @__PURE__ */ u(k, { children: /* @__PURE__ */ u(
        "button",
        {
          type: "button",
          class: "product-form__submit btn btn--outline --gold w-full",
          disabled: true,
          children: "Sold Out"
        }
      ) })
    ] }) });
  }
}
function ProductFormRegister() {
  register(ProductForm, "product-form", [
    "section",
    "url",
    "show-qty",
    "update-url",
    "product-options",
    "variant-data",
    "variant-meta",
    "color-options",
    "selling-plans",
    "initial-variant",
    "initial-availability",
    "requires-plan",
    "site-sale"
  ]);
}
ProductFormRegister();
